import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { StatisticService } from '../../../../../services/statistic.service';
import { MonthlyCohorts } from '../../../../../entities/index';

@Component({
  selector: 'app-dashboard-misc-monthly-cohorts',
  templateUrl: './monthly-cohorts.html',
})
export class MonthlyCohortsComponent implements OnInit, OnDestroy {
  stats: MonthlyCohorts[] = [];
  subscription: Subscription;
  loading = true;

  constructor(protected statisticService: StatisticService) {
  }

  ngOnInit(): any {
    this.subscription = this.statisticService
      .monthlyCohorts()
      .subscribe((result: MonthlyCohorts[]) => {
        this.stats = result;
        this.loading = false;
      });
  }

  ngOnDestroy(): any {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/pages/dashboard/misc/monthly-cohorts/monthly-cohorts.component.ts